import { calculateScrollBarWidth } from '@carvana/merch-react-hooks';
import { useEffect } from 'react';

export default function useSetScrollbarWidthProp() {
  useEffect(() => {
    let resizeTimeout: number;

    function onResize() {
      if (resizeTimeout) {
        window.cancelAnimationFrame(resizeTimeout);
      }

      resizeTimeout = window.requestAnimationFrame(() => {
        document.body.style.setProperty(
          '--scrollbar-width',
          `${calculateScrollBarWidth(true)}px`
        );
      });
    }

    onResize();

    window.addEventListener('resize', onResize, false);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
}
